

import { ReportConversationSessionService } from "@/services";
import { httpClientOmni } from "@/libraries";


const state = {
    data: [],
    totalSessions: 0,
    botOnlySessions: 0,
    agentSessions: 0,
    botOnlyRate: '0%',
    agentSessionRate: '0%',
    avgDurationWithBot: 0,
    avgBotMessageCount:0,
    loading: false,
    loadingCount: false,
    pagination: {
        current: 1,
        pageSize: 10,
        total: 0
    },
    search: '',
    masterHandler: [],
    masterChannel: [],
    masterStatus: [],
    masterIntegration: [],
}

const mutations = {
    SET_DATATABLE(state, data) {
        state.data = data.data
        state.pagination.total = data.total
    },
    SET_COUNT_REPORT(state, data) {
        state.totalSessions = data.total_sessions || 0;
        state.botOnlySessions = data.bot_only_sessions || 0;
        state.agentSessions = data.agent_sessions || 0;
        state.botOnlyRate = data.bot_only_rate || '0%';
        state.agentSessionRate = data.agent_session_rate || '0%';
        state.avgDurationWithBot = data.avg_duration_with_bot || 0;
        state.avgBotMessageCount = data.avg_bot_message_count || 0;
    },
    SET_LOADING(state, loading) {
        state.loading = loading
    },
    SET_LOADING_COUNT(state, loading) {
        state.loadingCount = loading
    },
    SET_PAGINATION(state, pagination) {
        state.pagination = { ...state.pagination, ...pagination }
    },
    SET_FILTER_TEXT(state, text) {
        state.search = text
    },
    SET_HANDLER(state, handlers) {
        state.masterHandler = handlers
    },
    SET_STATUS(state, status) {
        state.masterStatus = status
    },
    SET_CHANNEL(state, channel) {
        state.masterChannel = channel
    },
    SET_INTEGRATION(state, integration) {
        state.masterIntegration = integration
    }
}

const actions = {
    // OLD
    /*
    async fetchDatatable({ commit, state }) {
      try {
        commit('SET_LOADING', true)
        const response = await httpClientOmni.get('v3/whatsapp-flows/datatable', {
          params: {
            page: state.pagination.current,
            per_page: state.pagination.pageSize,
            sort: 'id|desc',
            search: state.search
          }
        })
        commit('SET_DATATABLE', response.data)
      } catch (error) {
        console.error(error)
      } finally {
        commit('SET_LOADING', false)
      }
    },
    */

    async fetchDatatable({ commit, state }, options = {}) {
        try {

            // const { commit, state } = context;  // Ambil commit dan state dari context

            const { filters = {}, sort = null } = options; // Use destructuring with default values
            commit('SET_LOADING', true);

            const response = await ReportConversationSessionService.datatable({
                page: state.pagination.current,
                per_page: state.pagination.pageSize,
                sort: sort,
                search: state.search,
                ...filters, // Spread filters to include additional options
            });

            commit('SET_DATATABLE', response.data);
        } catch (error) {
            console.error('Failed to fetch flows:', error);
        } finally {
            commit('SET_LOADING', false);
        }
    },


    async fetchCountReport({ commit, state }, options = {}) {
        try {
            const { filters = {}, sort = null } = options;
            commit('SET_LOADING_COUNT', true);

            const response = await ReportConversationSessionService.countReport({
                page: state.pagination.current,
                per_page: state.pagination.pageSize,
                sort: sort,
                search: state.search,
                ...filters,
            });

            commit('SET_COUNT_REPORT', response.data.data);
        } catch (error) {
            console.error('Failed to fetch count report:', error);
        } finally {
            commit('SET_LOADING_COUNT', false);
        }
    },


    async fetchStatus({ commit }) {
        try {
            const response = await httpClientOmni.get('v3/master/status-session-chat')
            if (response.data && Array.isArray(response.data.data)) {
                commit('SET_STATUS', response.data.data)
            }
        } catch (error) {
            console.error('Failed to fetch tags:', error)
        }
    },

    async fetchChannel({ commit }) {
        try {
            const response = await httpClientOmni.get('v3/master/channel')
            if (response.data && Array.isArray(response.data.data)) {
                commit('SET_CHANNEL', response.data.data)
            }
        } catch (error) {
            console.error('Failed to fetch channel:', error)
        }
    },

    async fetchHandler({ commit }) {
        try {
            const response = await httpClientOmni.get('v3/master/handler-session-chat')
            if (response.data && Array.isArray(response.data.data)) {
                commit('SET_HANDLER', response.data.data)
            }
        } catch (error) {
            console.error('Failed to fetch handler:', error)
        }
    },

    async fetchIntegration({ commit }, channelId) {
        try {
            if (channelId !== null) {
                const response = await httpClientOmni.get('v3/master/all-integration-by-app-id?channel_id=' + channelId)
                if (response.data && Array.isArray(response.data.data)) {
                    commit('SET_INTEGRATION', response.data.data)
                }
            } else {
                commit('SET_INTEGRATION', [])
            }
        } catch (error) {
            console.error('Failed to fetch channel:', error)
        }
    },

}

const getters = {
    statusOptions: state => state.masterStatus,
    handlerOptions: state => state.masterHandler,
    channelOptions: state => state.masterChannel,
    integrationOptions: state => state.masterIntegration,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}